<template>
	<div class="avatar">{{ initials }}</div>
</template>

<script setup>
	import {computed} from "vue";
	import { useSystemStore } from '@/stores/system/SystemStore'

	const systemStore = useSystemStore();
	const initials = computed(() =>  {
		const name = systemStore.user?.firstName +" "+systemStore.user?.lastName;
		return name.match(/(^\S\S?|\s\S)?/g).map(v=>v.trim()).join("").match(/(^\S|\S$)?/g).join("").toLocaleUpperCase();
	});
</script>

<style scoped>
	.avatar {
		@apply
		w-10 h-10
		rounded-3xl border-2 border-white
		text-white bg-gray-700
		text-center font-bold;
		line-height: 35px !important;
	}
</style>
